var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-box"},[_vm._l((_vm.tabs),function(item,idx){return [(item.code == _vm.config.profile )?_c(item.com,{key:idx,tag:"component"}):_vm._e()]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }